<template>
  <nav-bar :title="name" :back="goBack" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <!-- <div class="title">{{ name }}</div> -->
    <ul class="list" v-if="list.length">
      <li class="list-item" v-for="(item, index) in list" :key="item.userId"  @click="$router.push(`/userInfo/${item.userId}`)">
        <div class="row" >
          <span style="background-color: #b6e6ff;padding-left: 10px; width: 20px;">{{ index + 1 }}</span>
        </div>
        <div class="row">
          <span>客户：</span>
          <span style="margin-right: 5px;">{{ item.companyName }}</span>
          <van-tag :type="item.legalType === '0' ? 'primary' : 'danger'">{{item.legalType === '0' ? '合法' : '非法'}}</van-tag>
        </div>
        <div class="row">
          <span>联系人：</span>
          <span>{{ item.userName }}-{{ item.phoneNum }}</span>
        </div>
        <div class="row">
          <span>地址：</span>
          <span>{{ item.address }}</span>
        </div>
      </li>
    </ul>
    <Empty v-else />
  </Content>
</template>

<script>
import { ref, computed } from 'vue'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { StatisticsCustomerInfoByRegion } from '@/api/superviseHome'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  name: 'SuperviseUserList',
  props: ['name', 'stId'],
  setup(props) {
    const list = ref([])
    const store = useStore()
    const tenantId = computed(() => store.state.roleInfo.tenantId)
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      StatisticsCustomerInfoByRegion,
      data => {
        list.value = data || []
      },
      { stId: props.stId, tenantId: tenantId.value || '' }
    )
    getDataLoading()
    const router = useRouter()

    const streetLevel = computed(() => store.state.roleInfo.streetLevel)
    const goBack = () => {
      if (streetLevel.value >= 4) {
        router.go(-2)
      } else {
        router.back()
      }
    }
    return { getDataLoading, showLoading, isLoading, list, goBack, tenantId }
  }
}
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin-top: 16px;
}
.list {
  padding: 0 16px;
  margin-top: 16px;
  .list-item {
    padding: 10px;
    background-color: #fff;
    font-size: 12px;
    line-height: 24px;
    margin-bottom: 10px;
    .row {
      span:first-child {
        width: 60px;
        display: inline-block;
        color: #666;
      }
    }
  }
}
</style>
